import {
  CarrierVolumeOverTimeRequestSchema,
  CarrierVolumeOverTimeResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getCarrierVolumeOverTime = {
  name: "getCarrierVolumeOverTime" as const,
  input: CarrierVolumeOverTimeRequestSchema,
  output: CarrierVolumeOverTimeResponseSchema,
};
